import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initErrorReporter } from './errorReporter';
import './index.css';

// P0-1: 客户端错误上报 (window.onerror + unhandledrejection → /api/client-log)
initErrorReporter();

// Stale-deploy protection: tabs opened before a production deploy keep the old
// entry's hashed chunk names in memory; those files vanish when old releases
// are cleaned, so the next lazy import would fail and leave a broken page.
// Vite fires 'vite:preloadError' in that case — reload once to pick up the
// fresh entry and matching chunks.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

// /ozstaff 是 /cortex SPA 的别名入口，basename 跟随实际前缀，避免白屏。
const routerBasename = window.location.pathname.startsWith('/ozstaff') ? '/ozstaff' : '/cortex';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
